/**
 * 配置编译环境和线上环境之间的切换
 * 
 * Url: 域名地址
 * routerMode: 路由模式
 * baseImgPath: 图片存放地址
 * 
 */
// let Url = 'http://127.0.0.1:5005/';

let Url = 'http://39.105.46.197:5006/';
let grafana_Url = {
	edge_switch: 'https://114.118.82.135:3000/dashboard/snapshot/Dsq7VlIQQvLOIvc55sEtoU26F1r7AkfP?orgId=1',
	item_url: 'https://114.118.82.135:3000/dashboard/snapshot/DEQyfISG997AzHjlcAYrNnaEoT282KPp?orgId=1',
	h3c_switch: 'https://114.118.82.135:3000/dashboard/snapshot/Dsq7VlIQQvLOIvc55sEtoU26F1r7AkfP?orgId=1',
	huawei_switch: 'https://114.118.82.135:3000/dashboard/snapshot/Dsq7VlIQQvLOIvc55sEtoU26F1r7AkfP?orgId=1',
	hp_server: 'https://114.118.82.135:3000/dashboard/snapshot/c8iFaHB8S4WCrR6QzeKKsraVbAVvIrzD?orgId=1',
	lenovo_thinkserver: 'https://114.118.82.135:3000/dashboard/snapshot/c8iFaHB8S4WCrR6QzeKKsraVbAVvIrzD?orgId=1',
	lenovo_thinkagile: 'https://114.118.82.135:3000/dashboard/snapshot/c8iFaHB8S4WCrR6QzeKKsraVbAVvIrzD?orgId=1',
};
// let grafana_Url = 'https://118.25.83.174:3000/d/aec71276-bf6d-4169-be0f-9c13a2b95ce8/e6b581-e9878f-e59bbe?orgId=1&kiosk&var-items=';
// let grafana_Url = 'http://192.168.226.234:3000/d/cf2a368e-9629-4d91-a221-c5c667ac4e3e/e58e86-e58fb2-e6b581-e9878f-e8afa6-e68385?var-items=';
// let Url = 'http://192.168.226.234:5005/';
// let grafana_Url = {
// 	edge_switch: 'http://192.168.226.234:3000/d/bb421c94-9b2d-4fb6-b909-9062c8f6a2c9/e7abaf-e58fa3-e79bb8-e585b3-e4bfa1-e681af?orgId=1',
// 	item_url: 'http://192.168.226.234:3000/d/cf2a368e-9629-4d91-a221-c5c667ac4e3e/e58e86-e58fb2-e6b581-e9878f-e8afa6-e68385?orgId=1&var-items=',
// 	h3c_switch: 'http://192.168.226.234:3000/d/H3C_switch/h3c-e4baa4-e68da2-e69cba-e79b91-e68ea7?orgId=1&from=now-24h&to=now',
// 	huawei_switch: 'http://192.168.226.234:3000/d/Huawei_switch/e58d8e-e4b8ba-e4baa4-e68da2-e69cba-e79b91-e68ea7?orgId=1&from=now-24h&to=now',
// 	hp_server: 'http://192.168.226.234:3000/d/ZKGKfkeMz/133d7d6e-f865-5629-a705-534411d3a53e?orgId=1&from=now-24h&to=now',
// 	lenovo_thinkserver: 'http://192.168.226.234:3000/d/ThinkServer-SR660-V2/01f82cae-2fa8-57b8-9d78-f63e8fba2df9?orgId=1&from=now-24h&to=now',
// 	lenovo_thinkagile: 'http://192.168.226.234:3000/d/c9c602d3-c2eb-4013-8a85-5f70ad791068/b99d03e7-b935-5fe8-abf5-63c4ba2ef936?orgId=1&from=now-24h&to=now',
// };
let routerMode = 'hash';
let color_list = [
	"#4d99fc",
	"#7ce7fd",
	"#0c3283",
	"#1a9b97",
	"#233751",
	"#40faee",
];
let tooltip_basecss = {
	show: true,
	trigger: "item",
	triggerOn: "mousemove",
	confine: "true",
	axisPointer: {
		snap: true,
	},
	textStyle: {
		fontWeight: "bold",
		fontFamily: "Microsoft YaHei",
		fontSize: 20,
	},
	backgroundColor: "#333",
	borderColor: "#bbb",
	borderWidth: 3,
};

// let baseImgPath;

// if (process.env.NODE_ENV == 'development') {
// 	baseUrl = '';
// 	baseImgPath = '/img/';
// } else {
// 	// baseUrl = '//elm.cangdu.org';
// 	baseUrl = '';
// 	baseImgPath = '//elm.cangdu.org/img/';
// }

export {
	Url, grafana_Url,
	routerMode,
	color_list,
	tooltip_basecss,
}